import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from '../login/shared/login.service';
import { environment } from './../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../login/shared/login.service";
var AttendanceStatusService = /** @class */ (function () {
    function AttendanceStatusService(https, authenticate) {
        this.https = https;
        this.authenticate = authenticate;
        this.headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
    }
    AttendanceStatusService.prototype.getAttendanceStatus = function (staffid, search, group) {
        var params = new HttpParams();
        if (staffid) {
            params = params.append('staff_id', staffid);
        }
        if (search.length > 0) {
            params = params.append('search', search.join(','));
        }
        if (group) {
            params = params.append('group', group);
        }
        return this.https.get(environment.SERVER_URL + "/attendance_status", { headers: this.headers, params: params })
            .pipe(catchError(function (err) { return throwError(err); }));
    };
    //FILO
    AttendanceStatusService.prototype.getAttendancePerBranch = function () {
        var headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        return this.https.get(environment.SERVER_URL + "/attendance_status/filo", { headers: headers })
            .pipe(catchError(function (err) { return throwError(err); }));
    };
    AttendanceStatusService.prototype.downloadAttendanceStatus = function (from, to, staffid) {
        var params = new HttpParams();
        params = params.append('staff_id', staffid);
        params = params.append('from', from);
        params = params.append('to', to);
        var headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        return this.https.get(environment.SERVER_URL + "/attendance_status/download", { headers: headers, params: params, responseType: 'blob' })
            .pipe(catchError(function (err) { return throwError(err); }));
    };
    AttendanceStatusService.ngInjectableDef = i0.defineInjectable({ factory: function AttendanceStatusService_Factory() { return new AttendanceStatusService(i0.inject(i1.HttpClient), i0.inject(i2.LoginService)); }, token: AttendanceStatusService, providedIn: "root" });
    return AttendanceStatusService;
}());
export { AttendanceStatusService };
